import React from 'react';
import { CalendarCheck } from 'lucide-react';
import { useBooking } from '../context/BookingContext';

interface FloatingCTAProps {
  isVisible: boolean;
}

const FloatingCTA: React.FC<FloatingCTAProps> = ({ isVisible }) => {
  const { openModal } = useBooking();

  return (
    <div
      className={`fixed bottom-6 right-6 lg:right-12 z-40 transition-all duration-300 ease-[cubic-bezier(0.23,1,0.32,1)] transform ${isVisible ? 'translate-y-0 opacity-100 scale-100' : 'translate-y-8 opacity-0 scale-90 pointer-events-none'
        }`}
    >
      <button
        onClick={() => openModal()}
        className="bg-champagne hover:bg-amber-600 text-white font-bold text-[9px] lg:text-[10px] uppercase tracking-[0.2em] h-[48px] px-6 lg:px-8 rounded-full shadow-2xl shadow-champagne/40 transition-all flex items-center justify-center gap-2 active:scale-95 group border border-white/20"
      >
        <CalendarCheck className="w-4 h-4 flex-shrink-0" />
        <span className="lg:hidden">Book Now</span>
        <span className="hidden lg:block text-nowrap">Check Availability</span>
      </button>
    </div>
  );
};

export default FloatingCTA;